export default __webpack_public_path__ + "static/media/icon-invalid-expired.1e98de57.svg";